import React, { useContext } from 'react';
import { useSpring, animated } from 'react-spring';

import { ThemeContext } from '../theme/themeContext'



const AnimatedIcon = () => {
  const { colorMode, setColorMode } = useContext(ThemeContext);

  const properties = {
    dark: {
      r: 8,
      transform: "rotate(40deg)",
      cx: 16,
      cy: 10,
      opacity: 0
    },
    light: {
      r: 5,
      transform: "rotate(90deg)",
      cx: 36,
      cy: 0,
      opacity: 1
    },
    springConfig: { mass: 2, tension: 500, friction: 20 }
  };

  const { r, transform, cx, cy, opacity } = properties[
    colorMode === 'dark' ? "dark" : "light"
  ];

  const svgContainerProps = useSpring({
    transform,
    config: properties.springConfig
  });
  const centerCircleProps = useSpring({ r, config: properties.springConfig });
  const maskedCircleProps = useSpring({
    cx,
    cy,
    config: properties.springConfig
  });
  const linesProps = useSpring({ opacity, config: properties.springConfig });
  const circleProps = useSpring({
    opacity, transform, cx,
    cy, config: properties.springConfig
  })

  return (
    <animated.svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="var(--color-headingFont)"
      onClick={() => setColorMode(colorMode === 'dark' ? 'light' : 'dark')}
      style={{
        cursor: "pointer",
        margin: 0,
        ...svgContainerProps
      }}
    >
      <mask id="myMask2">
        <rect x="0" y="0" width="32" height="32" fill="#FBFAF9" />
        <animated.circle style={maskedCircleProps} r="8" fill="black"></animated.circle>
      </mask>

      <animated.circle
        cx="16"
        cy="16"
        style={centerCircleProps}
        fill="var(--color-headingFont)"
        mask="url(#myMask2)"
      />
      <animated.g stroke="var(--color-headingFont)" style={linesProps}>
        <circle cx="11" cy="7" r="1" fill="var(--color-headingFont)" style={circleProps}></circle>
        <circle cx="21" cy="25" r="1" fill="var(--color-headingFont)" style={circleProps}></circle>
        <circle cx="6" cy="16" r="1" fill="var(--color-headingFont)" style={circleProps}></circle>
        <circle cx="26" cy="16" r="1" fill="var(--color-headingFont)" style={circleProps}></circle>
        <circle cx="11" cy="25" r="1" fill="var(--color-headingFont)" style={circleProps}></circle>
        <circle cx="22" cy="7" r="1" fill="var(--color-headingFont)" style={circleProps}></circle>
      </animated.g>
    </animated.svg>
    // </IconDiv>
  );
};



export default AnimatedIcon;